import $dataStr from 'fxdom/es/dataStr.js';
import { go, html, strMap, map } from 'fxjs/es';
import { OMPCoreAtomTmplS } from '../../../Core/Atom/S/Tmpl/module/OMPCoreAtomTmplS.js';
import { OMPCoreCellTmplS } from '../../../Core/Cell/S/Tmpl/module/OMPCoreCellTmplS.js';
import { OMPProductListConstantS } from '../Constant/module/OMPProductListConstantS.js';
import { cateSelectorBody } from './cate_selector.js';
import { checkedFilterItemsWithReset } from './fn.js';
import { Icon } from '../../../../../services/Marpple/client/shared/ui/atoms/Icon/Icon.ts';
import { Switch } from '../../../../../services/Marpple/client/shared/ui/atoms/Switch/Switch.ts';
import { BodyNavigation } from '@services/Marpple/client/widgets/body-navigation/body-navigation.ts';

export const moCateSelect = ({ checked_cate_list, checked_cate_item }) => {
  const tt_all_cate_item = TT('product::list::list_9_1');
  return html`<div class="omp-product-list__cate-lists">
    <div class="omp-mo-product-header__select">
      <button
        type="button"
        data-cate_list_id="${checked_cate_list.id}"
        data-cate_item_id="${checked_cate_item?.id || ''}"
        data-campaign_id="${checked_cate_item?.campaign_id || ''}"
        class="omp-mo-product-header__checked-cate-list omp-product-list__checked-cate-list"
      >
        <span
          class="omp-mo-product-header__cate-item omp-product-list__cate-item--checked"
          data-id="${checked_cate_item?.id}"
        >
          ${checked_cate_item?.name || `${checked_cate_list.name} ${tt_all_cate_item}`}
        </span>
        <span class="omp-mo-product-header__checked-cate-list-arrow"
          >${OMPCoreAtomTmplS.arrowIcon({ direction: 'down' })}</span
        >
      </button>
    </div>
  </div>`;
};

export const moListBody = (bps, query = null) => {
  if (bps.length) {
    return html`<ul class="omp-product-list__list">
      ${strMap(OMPCoreCellTmplS.productMo, bps)}
    </ul>`;
  } else if (query?.is_biz) {
    return html`<div class="omp-product-list__no-list">
      <div class="omp-product-list__no-list-head">
        <h3 class="omp-product-list__no-list-title">${TT('product::list::list_22_1')}</h3>
        <div class="omp-product-list__no-list-content">${TT('product::list::list_22_2')}</div>
      </div>
      <a href="/biz">
        <button class="omp-product-list__no-list-btn primary">${TT('product::list::list_22_3')}</button>
      </a>
    </div>`;
  } else {
    return html`<div class="omp-product-list__no-list">
      <div class="omp-product-list__no-list-head">
        <h3 class="omp-product-list__no-list-title">${TT('product::list::list_24_1')}</h3>
        <div class="omp-product-list__no-list-content">${TT('product::list::list_24_2')}</div>
      </div>
      <button class="omp-product-list__no-list-btn omp-product-list__reset-filter-btn">
        ${TT('product::list::list_24_3')}
      </button>
    </div>`;
  }
};
export const moList = ({
  checked_cate_list,
  checked_filter_items,
  checked_cate_item,
  bps,
  query,
  bp_filters,
  cate_lists, // 현재 미사용중
}) => {
  const tt_filter = TT('product::list::list_16_1');
  const sort_list = OMPProductListConstantS.SORT_LIST().map((data) => {
    return {
      ...data,
      checked: data.id == query.sort,
    };
  });
  const checked_sort = sort_list.find(({ checked }) => checked);
  return html` <div class="omp-product-list">
    ${new BodyNavigation({
      items: go(
        checked_cate_list._.cate_list_sub_menus,
        map((item) => {
          return {
            id: item.id,
            label: item.name,
            image: item.mp_thumbnail_url,
            link: item.link.href,
            campaignId: item.campaign_id,
          };
        }),
      ),
      root: { label: TT('omp_layout::sub_menu_all_mo'), link: checked_cate_list.link.href },
      activeId: checked_cate_item?.campaign_id || checked_cate_item?.id || -1,
      className: 'utm_gnb_2',
    }).toHtml(true)}
    <div class="omp-product-list__mo_body">
      <div class="omp-mo-product-header">
        <div class="omp-mo-product-header__top">
          <div class="omp-product-list__flex-space-between">
            ${new Switch({
              id: 'omp-product-list__is-biz-switch',
              checked: query.is_biz?.toString() === 'true',
              label: TT('product::list::list_23_2'),
              size: 'sm',
            }).toHtmlSSR()}
            ${moCateSelect({ checked_cate_list, checked_cate_item })}
            <div class="omp-product-list__flex-space-between">
              <button class="omp-mo-product-header__filter-open-btn">
                ${new Icon({ name: 'filter' }).toHtml()} ${tt_filter}
                <span
                  class="omp-mo-product-header__filter-count opm-product-list-checked-filter-count"
                  data-count="0"
                  >(${bp_filters?.total_count || 0})</span
                >
              </button>
              <div class="omp-mo-product-header__sort">
                <div class="omp-mo-product-header__checked-sort">
                  <label class="omp-mo-product-header__checked-sort-name">
                    <span class="omp-product-list__checked-sort-name" data-id="${checked_sort.id}"
                      >${checked_sort.name}</span
                    >
                    ${new Icon({ name: 'arrow_down', size: 12 }).toHtml()}
                    <select class="omp-mo-product-header__sort-selector">
                      ${strMap((sort) => {
                        return html`
                          <option
                            class="omp-mo-product-header__sort-item"
                            data-id="${sort.id}"
                            data-name="${sort.name}"
                            value="${sort.id}"
                            ${checked_sort.id == sort.id ? ' selected' : ''}
                          >
                            ${sort.name}
                          </option>
                        `;
                      }, sort_list)}
                    </select>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="omp-product-cate-selector">
          <div class="omp-product-cate-selector__cate-lists">
            <div class="omp-product-cate-selector__cate-list-wrapper">
              ${cateSelectorBody({
                cate_lists,
                checked_cate_list_id: checked_cate_list?.id,
                checked_cate_item_id: checked_cate_item?.id,
              })}
            </div>
          </div>
        </div>
        <div
          class="omp-product-list__checked-filter-items opm-product-list-checked-filter-items"
          data-list_show="${checked_filter_items.length > 0}"
          ${bp_filters ? `data-fx-json="${$dataStr({ bp_filters })}"` : ''}
        >
          ${checkedFilterItemsWithReset(checked_filter_items)}
        </div>
      </div>
      <div
        class="omp-product-list__body opm-product-list-bps"
        data-filter_show="${checked_filter_items.length > 0}"
      >
        ${moListBody(bps, query)}
      </div>
    </div>
  </div>`;
};

export const moListNotFirstRender = ({
  checked_cate_list,
  checked_filter_items,
  checked_cate_item,
  bps,
  query,
  bp_filters,
  cate_lists, // 현재 미사용중
}) => {
  const tt_filter = TT('product::list::list_16_1');
  const sort_list = OMPProductListConstantS.SORT_LIST().map((data) => {
    return {
      ...data,
      checked: data.id == query.sort,
    };
  });
  const checked_sort = sort_list.find(({ checked }) => checked);
  return html` <div class="omp-product-list__mo_body">
    <div class="omp-mo-product-header">
      <div class="omp-mo-product-header__top">
        <div class="omp-product-list__flex-space-between">
          ${new Switch({
            id: 'omp-product-list__is-biz-switch',
            checked: query.is_biz?.toString() === 'true',
            label: TT('product::list::list_23_2'),
            size: 'sm',
          }).toHtmlSSR()}
          ${moCateSelect({ checked_cate_list, checked_cate_item })}
          <div class="omp-product-list__flex-space-between">
            <button class="omp-mo-product-header__filter-open-btn">
              ${new Icon({ name: 'filter' }).toHtml()} ${tt_filter}
              <span
                class="omp-mo-product-header__filter-count opm-product-list-checked-filter-count"
                data-count="0"
                >(${bp_filters?.total_count || 0})</span
              >
            </button>
            <div class="omp-mo-product-header__sort">
              <div class="omp-mo-product-header__checked-sort">
                <label class="omp-mo-product-header__checked-sort-name">
                  <span class="omp-product-list__checked-sort-name" data-id="${checked_sort.id}"
                    >${checked_sort.name}</span
                  >
                  ${new Icon({ name: 'arrow_down', size: 12 }).toHtml()}
                  <select class="omp-mo-product-header__sort-selector">
                    ${strMap((sort) => {
                      return html`
                        <option
                          class="omp-mo-product-header__sort-item"
                          data-id="${sort.id}"
                          data-name="${sort.name}"
                          value="${sort.id}"
                          ${checked_sort.id == sort.id ? ' selected' : ''}
                        >
                          ${sort.name}
                        </option>
                      `;
                    }, sort_list)}
                  </select>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="omp-product-cate-selector">
        <div class="omp-product-cate-selector__cate-lists">
          <div class="omp-product-cate-selector__cate-list-wrapper">
            ${cateSelectorBody({
              cate_lists,
              checked_cate_list_id: checked_cate_list?.id,
              checked_cate_item_id: checked_cate_item?.id,
            })}
          </div>
        </div>
      </div>
      <div
        class="omp-product-list__checked-filter-items opm-product-list-checked-filter-items"
        data-list_show="${checked_filter_items.length > 0}"
        ${bp_filters ? `data-fx-json="${$dataStr({ bp_filters })}"` : ''}
      >
        ${checkedFilterItemsWithReset(checked_filter_items)}
      </div>
    </div>
    <div
      class="omp-product-list__body opm-product-list-bps"
      data-filter_show="${checked_filter_items.length > 0}"
    >
      ${moListBody(bps, query)}
    </div>
  </div>`;
};
